// The idea is to store this data until we leave the page.

export const removeLastVisitedBookshelf = () => {
  return sessionStorage.removeItem('lastVisitedBookshelf');
};

export const getLastVisitedBookshelf = () => {
  return sessionStorage.getItem('lastVisitedBookshelf');
};

export const setLastVisitedBookshelf = (id) => {
  return sessionStorage.setItem('lastVisitedBookshelf', id);
};

export const setLastVisitedBinderName = (name) => {
  return sessionStorage.setItem('lastVisitedBinderName', name);
};

export const getLastVisitedBinderName = () => {
  return sessionStorage.getItem('lastVisitedBinderName');
};

export const setAcceptLanguage = (language) =>
  sessionStorage.setItem('acceptLanguage', language);

export const getAcceptLanguage = () => sessionStorage.getItem('acceptLanguage');
